import { FunctionComponent, useEffect } from "react"
import { useTypedSelector } from "../app/store"

type ChatGateProps = {
  children: React.ReactNode
}

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  function BrevoConversations(
    method: string,
    value?: string | number | boolean,
  ): void
}

const ChatGate: FunctionComponent<ChatGateProps> = ({ children }) => {
  const isAuthenticated = useTypedSelector(
    (state) => state.authSlice.isAuthenticated,
  )

  if (!isAuthenticated) {
    if (
      "BrevoConversations" in window &&
      typeof window["BrevoConversations"] === "function"
    ) {
      window.BrevoConversations("minimizeWidget")
      window.BrevoConversations("show")
    }

    // If the user remains on the login page for more than 10 seconds, show the widget
    // Once they navigate away from the login page, the timeout should be cancelled
    setTimeout(() => {
      if (
        !isAuthenticated &&
        "BrevoConversations" in window &&
        typeof window["BrevoConversations"] === "function"
      ) {
        window.BrevoConversations("expandWidget")
        window.BrevoConversations("startBotScenario", "xCYnqADFQyvHygy3c")
      }
    }, 10000)
    // Cancel timeout if user logs in
  }

  useEffect(() => {
    return () => {
      if (
        !isAuthenticated &&
        "BrevoConversations" in window &&
        typeof window["BrevoConversations"] === "function"
      ) {
        window.BrevoConversations("minimizeWidget")
      }
    }
  }, [isAuthenticated])

  return <>{children}</>
}

export default ChatGate
